import { Input, Typeahead } from '@youseedk/dna-react';
import React, { useState } from 'react';

import { Button } from '@mui/material';
import { cookieDomains } from 'components/navigation/Utils/constants';
import { post } from 'shared/utils/api';
import { errorCodeHandler } from 'shared/utils/api/request';
import { cookies } from 'shared/utils/storage/cookies';
import { local } from 'shared/utils/storage/local-storage';
import { featLoginWithCiamPing } from 'utils/feature-toggle/feat-login-with-ciam-ping';

const getSuggestions = (username) => {
  const testLogins = local.get('test_logins') ?? [];
  const logins = testLogins
    .filter((login) => login.username.startsWith(username))
    .sort((login1, login2) => login2.lastLogin - login1.lastLogin);

  return logins;
};

export const EasyLogin = () => {
  const [suggestions, setSuggestions] = useState(getSuggestions(''));
  const [username, setUsername] = useState({
    value: suggestions[0]?.username || '',
  });
  const [password, setPassword] = useState({
    value: suggestions[0]?.password || '',
  });

  const onSubmit = (e) => {
    e.preventDefault();
    const payload = {
      username: username.value,
      password: password.value,
    };
    loginUser(payload).then(() => {
      const logins = local.get('test_logins') || [];
      const login = logins.find((login) => login.username === username.value);
      if (login) login.lastLogin = Date.now();

      local.set(
        'test_logins',
        login ? logins : [...logins, { ...payload, lastLogin: Date.now() }],
      );

      location.reload();
    });
  };

  return (
    <div className='navpanel__item-link' style={{ overflow: 'visible' }}>
      <form action='submit' onSubmit={onSubmit}>
        <Typeahead
          label='Username'
          value={username.value}
          onChange={(data) => {
            setUsername(data);
            setSuggestions(
              getSuggestions(data.value).map((login) => ({
                text: login.username,
              })),
            );
          }}
          suggestions={suggestions}
          valid
          required
        />
        <Input label='Password' onChange={setPassword} value={password.value} />
        <Button variant='cta' fullWidth type='submit' sx={{ marginTop: 4 }}>
          Submit
        </Button>
      </form>
    </div>
  );
};

const loginUser = (data: { username: string; password: string }) => {
  return post({
    url: '/profile/authenticate',
    data,
    baseURL: 'https://t-odinapi.internal.yousee.dk',
    headers: {
      'X-TDC-YSPRO-INSTANCE': 'test',
    },
    requireAuth: false,
  })
    .then((authDetails) => {
      cookieDomains.forEach((domain) => {
        const expiration = 24;
        Object.entries({
          yspro: authDetails.sessionId,
          TestUserName: data.username,
          BcInstance: featLoginWithCiamPing() ? 'test11jwt' : 'test11',
          YSProInstance: 'test',
          KasiaInstance: 'test',
          OssiInstance: 'test',
          access_token: authDetails.accessToken,
          MailMicroserviceInstance: 'test',
        }).forEach(([cookie, value]) =>
          cookies.set(cookie, value, expiration, {
            secure: 'true',
            SameSite: 'None',
            domain,
          }),
        );
      });
      return authDetails;
    })
    .catch((data) => errorCodeHandler(data));
};
